// Thumbnail generator
const generateThumbnail = (id, spec, size, focus, series) => {
  let thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${spec}&type=prod&extra=(focus=${focus})&Size=${size}`;

  if (series === 8489) {
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(${spec})&type=prod&extra=(focus=${focus})&Size=${size}`;
  }

  if(spec.indexOf("Hexagon") !== -1 ){
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${spec}&extra=(design=(seed=12661).focus=(@size[x]/@res[x]),size=(?,(@x*@res[y]/@res[x])))&size=256`;
  }

  if(spec.indexOf("Triangles") !== -1 ){
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${spec}&extra=(design=(seed=12661).focus=(@size[x]/@res[x]),size=(?,(@x*@res[y]/@res[x])))&size=256`;
  }

  return thumbnail;
};

export { generateThumbnail };
